import Vue from 'vue'
import Router from 'vue-router'
// import Login from '@/views/login/Login'
import HomeContent from '@/views/officalweb/index'
import Offical from './modules/offical'

import ManageContent from '@/views/manage/index'
import Manage from './modules/manage'

Vue.use(Router)

const router = new Router({
  routes: [
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: Login
    // },
    {
      path: '/',
      name: 'home',
      component: HomeContent,

      children: [
        ...Offical
      ]
    },
    {
      path: '/manage',
      name: 'manage',
      component: ManageContent,

      children: [
        ...Manage
      ]
    }
  ]
})

router.beforeEach(function (to, from, next) {
  console.log(to, from, next, 'beforeEach')
  console.log(to,"tooooo")
  console.log(next,"next")
  // if (!sessionStorage.getItem('token')) {
  //   if (to.path !== '/login') {
  //     return next('/login')
  //   }
  // }
   /* 路由发生变化修改页面title */
   if (to.meta.name) {
    document.title = to.meta.name + '-'+ '全国区块链和分布式记账技术标准化技术委员会'
    }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js